module.exports = __webpack_public_path__ + "img/Icons for SPIM Sidebar-53.ac1e91b7.svg";